<div class="header-title">
  <div class="container-banner">
    <img class="title-image" src="../../../assets/profile-menu/BannerPreguntasFrecuentes.png" alt="">
  </div>
</div>
<div class="question-container">
  <aside class="question-topics">
    <ul>
      <li
        *ngFor="let topic of topics"
        [class.selected]="isSelected(topic)"
        (click)="selectTopic(topic)"
      >
        {{ topic }}
      </li>
    </ul>
  </aside>
  <div class="questions-answer">
    <div class="search-bar">
      <input
        class="input-search"
        placeholder="Buscar.."
        (input)="onSearchTermChange($event)"
      />
    </div>
    <div *ngIf="getFilteredQuestions().length === 0">
      No se encontraron resultados.
    </div>
    <div *ngFor="let question of getFilteredQuestions()">
      <h4>{{ question.question }}</h4>
      <div [innerHTML]="question.answer"></div>
    </div>
  </div>
</div>
